import styled from 'styled-components';

import { ProductSkeleton } from '@sharedComponents/Skeletons';

export const StyledProductSkeleton = styled(ProductSkeleton)`
  padding-bottom: 1rem;
`;
